
import AppSection from "./AppSection"
export default {
  components: {
    AppSection
  },
  props: {
    heading: {
      type: String,
      default: ""
    },
    isBackgroundCentred: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isHeadingLowerCase: {
      type: Boolean,
      default: false
    },
    subheading: {
      type: String,
      default: ""
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    backgroundImage: {
      type: String,
      default: ""
    },
    responsiveBackgroundImage: {
      type: Array,
      default: null
    },
    headingColumns: {
      type: String,
      default: ""
    },
    subheadingColumns: {
      type: String,
      default: ""
    }
  },
  computed: {
    headingClasses() {
      const classes = []
      if (this.isHeadingLowerCase) {
        classes.push("general-hero__heading-lowercase")
      }
      if (this.headingColumns) {
        classes.push("column")
        classes.push(this.headingColumns)
      } else {
        classes.push("condensed-normal")
      }
      return classes
    },
    subheadingClasses() {
      const classes = []
      if (this.subheadingColumns) {
        classes.push("column")
        classes.push(this.subheadingColumns)
      } else {
        classes.push("condensed-normal")
      }
      return classes
    }
  }
}
